<template>
  <div class="discovery-root">
    <div v-if="item" class="discovery-recommendation-view" ref="item">
      <div class="discovery-rec-cover">
        <div class="discovery-item-cover-image">
          <item-image :item="item" size="large"/>
        </div>
      </div>
      <div class="discovery-rec-details">
        <a :href="JsPAPI.util.itemURL(
          item,
          JsPAPI.api.getConfig(),
        )">
          <h2 class="discovery-item-title" v-if="title">{{ title }}</h2>
          <h2 class="discovery-item-title" v-else>{{ item.Title }}</h2>
        </a>
        <div v-if="item.Author" class="discovery-item-author">
          {{ JsPAPI.util.cleanAuthor(item.Author) }}
        </div>
        <div v-if="item.Summary" class="discovery-item-summary">
          {{ JsPAPI.util.truncate(item.Summary, 400) }}
        </div>
      </div>
      <div class="discovery-rec-blurb" v-if="blurb">
        <div class="discovery-rec-inner-blurb" v-html="blurb" />
      </div>
    </div>
  </div>
</template>

<script>
import ItemImage from '@/components/ui/ItemImage.vue';
/**
 * Example use:
 *
 * Discovery.vueLoader('Recommendation', '#target-dom-element', {
 *   cn: 185554,
 *   blurb: '<div>example blurb</div>',
 * });
 */

export default {
  name: 'HoverCover',
  components: {
    ItemImage,
  },
  props: [
    'test_cn',
    'test_blurb',
  ],
  data() {
    return {
      item: null,
      data: null,
      cn: this.$root.params.cn ?? this.test_cn,
      blurb: this.$root.params.blurb,
      title: this.$root.params.title,
      mode: this.$root.params.mode ?? 'default',
    };
  },
  // On load get bib record from pac
  async created() {
    this.blurb = this.blurb.replace(/\n|\r|\r\n/, '').trim();
    const rq = await this.JsPAPI.api.bibSearchKW(this.cn, 'CN');
    Discovery.log('Received item data');
    [this.item] = rq.data.BibSearchRows;
  },
};

</script>

<style lang="less">
@import '~@/css/global';
.discovery-recommendation-view {
  .shadow();
  margin-bottom: 12px;
  border: 1px solid #DDD;
  display: flex;
  flex-wrap: wrap;
  .discovery-rec-cover {
    flex: 0 0 240px;
    padding: 12px;
  }
  .discovery-rec-details,
  .discovery-rec-blurb {
    flex: 1 0 300px;
    padding: 12px;
  }
  .discovery-item-title {
    margin: 0;
  }
  .discovery-item-author {
    margin-bottom: 1em;
  }
  .discovery-rec-blurb {
    line-height: 14pt;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #EDEDED;
  }
  .discovery-rec-inner-blurb {
    position: relative;
    text-align: center;
    font-size: 16pt;
    &::before {
      content: '“';
      font-size: 60px;
      line-height: 1px;
      color: #666;
      position: absolute;
      top: 20px;
      left: -20px;
    }
    &::after {
      content: '”';
      line-height: 1px;
      color: #666;
      position: absolute;
      font-size: 60px;
      bottom: -10px;
      right: -10px;
    }
  }
}

</style>
